export const NAME_SPACE = 'Line/';
export const ROOT_STATE_KEY = 'line';
